import {Injectable} from "@angular/core";
import {AbstractResourceService} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {CustomerDetailsDTO, CustomerDTO, TerritoryDTO} from "@well/domain";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CompanyCustomerResourceService extends AbstractResourceService<undefined, CustomerDTO, undefined, undefined> {

  constructor(protected httpClient: HttpClient, private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('companyCustomerUrl'),
      undefined,
      CustomerDTO
    );
  }

  update(customerDetailsDTO: CustomerDetailsDTO): Observable<CustomerDTO> {
    return this.httpClient
      .put(`${this.url}`, customerDetailsDTO, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }

  patchFavourite(uuid: string){
    return this.httpClient.patch(`${this.url}/favourite/${uuid}`, null);
  }

  patchTerritory(uuid: string, territory: TerritoryDTO){
    return this.httpClient.patch(`${this.url}/territory/${uuid}`, territory);
  }

  customerExists(country: string, uniqueIdentificationNumber: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.url}/exists/${country}/${uniqueIdentificationNumber}`);
  }
}
